// extracted by mini-css-extract-plugin
export default {"title":"XYsbxQ","text":"OBb2Nx"};